import React from 'react'

import { PreloaderSpiner } from '../PreloaderSpinner/PreloaderSpiner'
import style from './PreloaderPage.module.scss'

function PreloaderPage() {
  return (
    <div className={style.PreloaderPage}>
      <PreloaderSpiner />
    </div>
  )
}

export default PreloaderPage
